import { IApplicationState } from '../../types/redux';

export const selectConstructionProgressPage = (state: IApplicationState): number => {
  const { page } = state.constructionProgressData;

  return page;
};
